import {useState,useSyncExternalStore,type Dispatch,type SetStateAction} from 'react';
import {operationKey} from '../api';

const drafts = new Map<string, unknown>();
const listeners=new Set<()=>void>();
let revision=0;
const subscribe=(listener:()=>void)=>{listeners.add(listener);return()=>{listeners.delete(listener);};};
const changed=()=>{revision++;for(const listener of listeners)listener();};
export function clearBusinessEvidenceDrafts(){drafts.clear();changed();}
/** Private in-memory state, cleared on actor changes; originals and receipts live on the server. */
export function useBusinessDraft<T>(key:string,initial:()=>T):[T,Dispatch<SetStateAction<T>>]{
 const [initialValue]=useState<T>(()=>drafts.has(key)?drafts.get(key) as T:initial());
 const value=useSyncExternalStore(subscribe,()=>drafts.has(key)?drafts.get(key) as T:initialValue);
 const update:Dispatch<SetStateAction<T>>=next=>{
  const previous=drafts.has(key)?drafts.get(key) as T:initialValue;
  const result=typeof next==='function'?(next as (old:T)=>T)(previous):next;
  drafts.set(key,result);changed();
 };
 return [value,update];
}
export type BusinessIntent={key:string;body:string|null;path:string|null;definitive:boolean;uncertain:boolean};
export const newBusinessIntent=():BusinessIntent=>({key:operationKey(),body:null,path:null,definitive:false,uncertain:false});
export function useRetainedBusinessRequests(actorId:string,path:string){
 useSyncExternalStore(subscribe,()=>revision);
 return [...drafts.entries()].flatMap(([stateKey,value])=>{
  if(!stateKey.startsWith(actorId+':business-')||!value||typeof value!=='object')return [];
  const intent=value as Partial<BusinessIntent>;
  return typeof intent.key==='string'&&typeof intent.body==='string'&&typeof intent.path==='string'&&intent.path.startsWith(path+'/')&&intent.uncertain===true&&!intent.definitive?[{stateKey,intent:intent as BusinessIntent}]:[];
 });
}
export function resolveBusinessRequest(stateKey:string){drafts.set(stateKey,newBusinessIntent());changed();}
